import { upsertTaskFilterGroup } from '@dispatch/shared/services';
import { TaskFilterGroup } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';

export const useUpsertTaskListFilterGroup = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>,
  userId: string
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-task-filter-group', userId],
    (data: TaskFilterGroup) =>
      upsertTaskFilterGroup(
        {
          ...data,
          userId,
        },
        userId
      ),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    upsertTaskFilterGroup: mutate,
    upsertTaskFilterGroupError: error,
    upsertTaskFilterGroupStatus: status,
  };
};
